var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0043 9.47852C10.0908 9.47844 10.1753 9.45274 10.2472 9.40466C10.319 9.35658 10.375 9.28828 10.4081 9.20839C10.4412 9.12849 10.4499 9.04059 10.433 8.95577C10.4162 8.87095 10.3746 8.79303 10.3135 8.73185L6.23012 4.64852C6.14809 4.56659 6.0369 4.52057 5.92096 4.52057C5.80502 4.52057 5.69382 4.56659 5.61179 4.64852L1.52846 8.73185C1.46735 8.79303 1.42574 8.87095 1.4089 8.95577C1.39205 9.04059 1.40071 9.12849 1.43379 9.20839C1.46687 9.28828 1.52289 9.35658 1.59476 9.40466C1.66664 9.45274 1.75115 9.47844 1.83762 9.47852L10.0043 9.47852Z",
    fill: "#2D6CDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.6d33ad059365d02af5b39543e0af4f4e.svg";
export { ForwardRef as ReactComponent };